import { Box, Stack, Typography } from '@mui/material';

/** Scannable bullet list for concern cards and adjudicator briefs. */
export function FindingBriefBullets({
  items,
  accent,
}: {
  items: string[];
  accent?: string;
}) {
  if (!items.length) return null;
  return (
    <Stack component="ul" spacing={0.55} sx={{ m: 0, pl: 0, listStyle: 'none' }}>
      {items.map((item) => (
        <Stack key={item} component="li" direction="row" spacing={0.75} alignItems="flex-start">
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: accent ?? 'primary.main',
              opacity: 0.8,
              mt: 0.62,
              flexShrink: 0,
            }}
          />
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, lineHeight: 1.55, fontSize: '0.875rem', color: 'text.primary' }}
          >
            {item}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
